import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
// Available map information at current mouse position on map
// rendered in CSS grid
@customElement('voyage-info')
export class VoyageInfo extends LitElement {

    static get styles() {
        return css`
            .grid-container {
                font-family: var(--component-heading-ff, "serif");
                font-size: 11px;
                border: 1px solid var(--neutrals-grey-01, black);
                padding: 2px;   
                display: grid;
                grid-template-columns: 60px auto;
                grid-column-gap: 5px;
            }
           .grid-container-2nd {
                border-top: none;
           }
           .warn {
                font-family: var(--component-heading-ff, "serif");
                font-size: 11px;
                background-color: var(--voyage-info-warn-background-color, red);
                padding: 2px;
           }
        `;
    }

    render(){
        
        return html`
        <div class="grid-container">
          <div>Lat</div><div>${this._lat}</div>
          <div>Lon</div><div>${this._lon}</div>
          <div>X</div><div>${this._x.toFixed(6)}</div>
          <div>Y</div><div>${this._y.toFixed(6)}</div>
        </div>
        <div class="grid-container grid-container-2nd">
          <div>X (fix)</div><div>${this._xFix.toFixed(6)}</div>
          <div>Y (fix)</div><div>${this._yFix.toFixed(6)}</div>
        </div>
        ${this._imo && this._name ? html`
        <div class="grid-container grid-container-2nd">
          ${this._imo           ? html`<div>IMO</div><div>${this._imo}</div>`:''}
          ${this._name          ? html`<div>Name</div><div>${this._name.replace(/\(IMO\d+\)/, '')}</div>`:''}
        </div>` : ''}
        ${this._warning         ? html`<div class="warn">${this._warning}</div>`:''}
        ${this._layer ? html`
        <div class="grid-container grid-container-2nd">
          ${this._layer         ? html`<div>Type</div><div>${this._layer}</div>`:''}
          ${this._hurricaneName ? html`<div>Hurricane</div><div>${this._hurricaneName}</div>`:''}
          ${this._icebergName   ? html`<div>Iceberg</div><div>${this._icebergName}</div>`:''}
          ${this._value         ? html`<div>Value</div><div>${this._value}</div>`:''}
          ${this._direction     ? html`<div>Direction</div><div>${this._direction}</div>`:''}
          ${this._startTime     ? html`<div>Start Time</div><div>${this._startTime}</div>`:''}
          ${this._endTime       ? html`<div>End Time</div><div>${this._endTime}</div>`:''}
          ${this._from          ? html`<div>From</div><div>${this._from}</div>`:''}
          ${this._to            ? html`<div>To</div><div>${this._to}</div>`:''}
          ${this._windSpeed     ? html`<div>Wind Speed</div><div>${this._windSpeed}</div>`:''}
        </div>` : ''}
        `;
    }

    handleClick(evt: CustomEvent){
        if ((<any>window)["appenv"].featureToggles.routeTester) {
            // Copy the coordinates to clipboard
            const temp = document.createElement('input');
            temp.value = `${evt.detail.pos.x},${evt.detail.pos.y}`;
            document.body.appendChild(temp);
            temp.select();
            document.execCommand('copy');
            document.body.removeChild(temp);
            console.log(`Copied [${temp.value}] to clipboard`);
        }
        this._xFix = evt.detail.pos.x;
        this._yFix = evt.detail.pos.y;
        const info = evt.detail.info;
        this._imo   = info.imoNo;
        this._name  = (info.name || '').replace(/ \(.*/, '');
        this._layer = info.layer;
        this._value = info.Value;
        this._direction = info.Direction;
        this._startTime = (info.StartTime || '').substring(0, 16);
        this._endTime   = (info.EndTime   || '').substring(0,16);
        this._from  = info.From;
        this._to    = info.To;
        this._hurricaneName = info.HurricaneName;
        this._icebergName = info.IcebergName;
        this._windSpeed = info.WindSpeed;
        this._warning = ((info.name || '').match(/position[^\)]*/) || [])[0];
    }

    handleMove(evt: CustomEvent){
        this._x = evt.detail.pos.x;
        this._y = evt.detail.pos.y;
        this._lat = evt.detail.pos.lat;
        this._lon = evt.detail.pos.lon;
    }
    
    @property({attribute: false}) private _lat: string = "";
    @property({attribute: false}) private _lon: string = "";
    @property({attribute: false}) private _x: number = 0;
    @property({attribute: false}) private _y: number = 0;
    @property({attribute: false}) private _xFix: number = 0;
    @property({attribute: false}) private _yFix: number = 0;
    // features
    @property({attribute: false}) private _imo: string|null = null;
    @property({attribute: false}) private _name: string|null = null;
    @property({attribute: false}) private _layer: string|null = null;
    @property({attribute: false}) private _value: string|null = null;
    @property({attribute: false}) private _direction: string|null = null;
    @property({attribute: false}) private _startTime: string|null = null;
    @property({attribute: false}) private _endTime: string|null = null;
    @property({attribute: false}) private _from: string|null = null;
    @property({attribute: false}) private _to: string|null = null;
    @property({attribute: false}) private _hurricaneName: string|null = null;
    @property({attribute: false}) private _icebergName: string|null = null;
    @property({attribute: false}) private _windSpeed: string|null = null;
    @property({attribute: false}) private _warning: string|null = null;

}
